export default __webpack_public_path__ + "static/media/Group 36.e2ef0d54.svg";